type MessageHub = typeof import("@clover-native/message-hub");

let messageHubPromise: Promise<MessageHub> | undefined;

const loadMessageHub = (): Promise<MessageHub | undefined> => {
  if (globalThis.window === undefined) {
    return Promise.resolve(undefined);
  }

  messageHubPromise ??= import("@clover-native/message-hub");
  return messageHubPromise;
};

export const sendEvent = async (
  ...args: Parameters<MessageHub["sendEvent"]>
): Promise<void> => {
  const messageHub = await loadMessageHub();
  messageHub?.sendEvent(...args);
};

export const sendMessage = async (
  ...args: Parameters<MessageHub["sendMessage"]>
): Promise<unknown> => {
  const messageHub = await loadMessageHub();
  return messageHub?.sendMessage(...args);
};

export const subscribe = (
  ...args: Parameters<MessageHub["subscribe"]>
): (() => void) => {
  let active = true;
  let unsubscribe: () => void = () => undefined;

  void loadMessageHub().then((messageHub) => {
    if (!active || !messageHub) return;
    unsubscribe = messageHub.subscribe(...args);
  });

  return () => {
    active = false;
    unsubscribe();
  };
};